import {
  useState,
  useEffect,
  useCallback,
  useMemo,
} from 'react';

const useScheduleQueue = (activeChannelId) => {
  const [scheduleQueue, setScheduleQueue] = useState([]);

  useEffect(() => {
    setScheduleQueue([]);
  }, [activeChannelId]);

  const handleAddToScheduleQueue = useCallback((text, messageId) => {
    setScheduleQueue((prev) => {
      const without = prev.filter((r) => r.messageId !== messageId);
      return without.length < prev.length ? without : [...without, { text, messageId }];
    });
  }, []);

  // Guard against unchanged values to avoid re-renders on every keystroke
  const handleQueueTextChange = useCallback((index, value) => {
    setScheduleQueue((prev) => prev.map((r, i) => (i === index && r.text !== value ? { ...r, text: value } : r)));
  }, []);

  const scheduledMessageIds = useMemo(
    () => scheduleQueue.map((r) => r.messageId),
    [scheduleQueue],
  );

  return useMemo(() => ({
    scheduleQueue,
    scheduledMessageIds,
    handleAddToScheduleQueue,
    handleQueueTextChange,
    setScheduleQueue,
  }), [scheduleQueue, scheduledMessageIds, handleAddToScheduleQueue, handleQueueTextChange]);
};

export default useScheduleQueue;
